import styled from 'styled-components';


const Content = styled.div`
  border-bottom: 1px solid #ebebeb;

  .filters {
    display: none;
    padding-top: 0;

    label:not(:last-child){
      margin-bottom: 12px;
    }
  }

  .icon {
    transition: transform 0.1s ease-in;
    transform: rotate(180deg);
  }

  &.expanded {
    .filters {
      display: block;
    }
    .icon {
      transform: rotate(360deg);
    }
  }
`;

const Header = styled.div`
display: flex;
justify-content: space-between;
padding: 18px;
cursor: pointer;

> span {
  color: #016bc2;

  &:first-child {
    font-weight: 600;
  }
}
`;

const Body = styled.div`
  padding: 0 30px 16px 18px;
`;

export { Content, Header, Body };


// WEBPACK FOOTER //
// ./src/components/layouts/advancedFilters/styles.js